<template>
  <v-app>
      <Loader />
      <SystemDialog />
      <SystemDialogOptions />
      <router-view/>
  </v-app>

</template>

<script>
import Loader from '@/components/Loader.vue'
import SystemDialog from './components/SystemDialog.vue';
import SystemDialogOptions from './components/SystemDialogOptions.vue';

export default {
  name: 'App',
  components: {
    Loader,
    SystemDialog,
    SystemDialogOptions
  },
  data: () => ({
    //
  }),
};
</script>

<style>
html, body {
  overflow: hidden;
  margin: 0 !important;
  padding: 0 !important;
  height: 100%;
}
</style>